// Ejar calculation item types (Contract/GetContractCalculationInformation, `itemTypeId`). The page's one copy
// of the engine's fines_pipeline/ejar_client.py CALC_* ids (audit DUP-28): same numbers, named once.
export const EJAR_CALC_ITEM = Object.freeze({
    rent: 1,              // Trip Days
    extraHours: 2,
    fuel: 4,
    fines: 5,
    parkingFees: 13,
    tolls: 14,            // Salik at close
    unlimitedSalik: 16,   // a per-day add-on
    otherCharges: 23,
});
